import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const EyeGlyph = /*#__PURE__*/createElement("g", {
  id: "eye"
}, /*#__PURE__*/createElement("path", {
  d: "M69.05 41.01c-.49-.56-12.22-13.82-27.05-13.82S15.44 40.45 14.95 41.01c-.49.57-.49 1.41 0 1.97.49.57 12.23 13.83 27.05 13.83 14.81 0 26.56-13.26 27.05-13.82.49-.57.49-1.41 0-1.98zm-27.71-4.38a3.82 3.82 0 11-7.64 0 3.82 3.82 0 017.64 0zM42 53.81C30.8 53.81 21.12 45 18.15 42c2.26-2.28 8.41-7.92 16.16-10.49-2.49 2.14-4.07 5.3-4.07 8.83 0 6.43 5.22 11.64 11.64 11.64 6.43 0 11.63-5.22 11.64-11.64 0-3.59-1.63-6.8-4.19-8.94 7.92 2.51 14.23 8.28 16.52 10.6C62.89 45 53.23 53.81 42 53.81z"
}));
const Eye = createSvg({
  name: 'eye',
  path: EyeGlyph
});

export default Eye;
export { EyeGlyph };
